import $ from 'jquery'
import { trackGtmEvent } from '../../util/tracking'

const getSelectedLabel = id => {
  const value = $('.dhsv_vc_akademie_formular #' + id).val()
  return $(`.dhsv_vc_akademie_formular #${id} option[value="${value}"]`).text()
}

const getValue = id => $('.dhsv_vc_akademie_formular #' + id).val()

const getCount = id =>
  $(`.dhsv_vc_akademie_formular #${id} .gfield_list tbody tr`)
    .toArray()
    .filter(tr =>
      $(tr)
        .find('input')
        .toArray()
        .every(input => !!$(input).val())
    ).length

const getAllDimensions = () => ({
  dimension1: getSelectedLabel('input_4_3'), // ausgewählte Zielgruppe / Trainingstyp
  dimension2: getSelectedLabel('input_4_4'), // ausgewählte Modul Nummer
  dimension3: getSelectedLabel('input_4_5'), // ausgewählter Trainingstermin
  dimension4: getValue('input_4_48'), // Gutscheincode
  dimension5: getCount('field_4_17'),
})

$(document).on('click', 'button.dhsv_vc_akademie_formular_button', () => {
  trackGtmEvent('FA_eventTracking', { FA_interaction: 'form_open' })
})

const trackSteps = () => {
  let lastPage = '1'
  let finalDimensions = {}

  $(document).on('gform_page_loaded', function (event, formId, currentPage) {
    if (formId !== 4) {
      return
    }

    const didChangePage = currentPage !== lastPage
    const forward = currentPage > lastPage

    if (!didChangePage) {
      return
    }

    trackGtmEvent('FA_eventTracking', {
      FA_interaction: `step${lastPage} – ${forward ? 'next' : 'back'}`,
      ...getAllDimensions(),
    })

    // this should always be the last line
    lastPage = currentPage
  })

  $(document).on('click', '#gform_submit_button_4', () => {
    finalDimensions = getAllDimensions()
  })

  $(document).on('gform_confirmation_loaded', function (event, formId) {
    if (formId !== 4) {
      return
    }

    trackGtmEvent('FA_eventTracking', {
      FA_interaction: `step${lastPage} – sent`,
      ...finalDimensions,
    })
  })
}

trackSteps()
